import { Text } from '@viapeople/components'
import { useMemo } from 'react'
import { useFormBuilderStore } from '../store'
import type { ComponentDefinition } from '../store/componentRegistry'
import { ComponentPaletteCard } from './ComponentPaletteCard'

export function ComponentPalette() {
	const componentRegistry = useFormBuilderStore((state) => state.componentRegistry)

	const groupedComponents = useMemo(() => {
		const groups: Record<string, ComponentDefinition[]> = {}

		componentRegistry.forEach((component) => {
			const category = component.category
			if (!groups[category]) {
				groups[category] = []
			}
			groups[category].push(component)
		})

		return groups
	}, [componentRegistry])

	return (
		<div className='p-4 sticky top-0 overflow-y-auto overflow-x-hidden'>
			{Object.entries(groupedComponents).map(([category, components]) => (
				<div key={category} className='mb-6'>
					<Text variant='xsmall' weight='semibold' className='text-neutral-500 mb-2 capitalize text-left'>
						{category}
					</Text>

					{components.map((component) => (
						<ComponentPaletteCard key={component.id} component={component} />
					))}
				</div>
			))}
		</div>
	)
}
